import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoSize: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="auto-size, automatic-size, page"><path d="M4.75 11.75H12.25V21.25M4.75 11.75V21.25H12.25M4.75 11.75V2.75H19.25V21.25H12.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAutoSize;
